import React from 'react';
import { useSnackbarContext } from 'context/snackbar.context';
import { convertHTMLStringToEditorState } from 'utils/formatting';
import { Editor } from 'react-draft-wysiwyg';
import styled from 'styled-components';

const RichTextContainer = styled.div`
  * {
    margin: 0;
  }

  .rdw-editor-toolbar {
    display: none;
  }
`;

interface RichTextProps {
  value: string;
}

type Props = RichTextProps;

const RichText = ({ value }: Props) => {
  const { displaySnackbarMessage } = useSnackbarContext();
  // try catch is placed here to not break the page in case data is not JSON-parseable
  try {
    const richTextEditorState = convertHTMLStringToEditorState(value);
    return (
      <RichTextContainer>
        <Editor defaultEditorState={richTextEditorState} readOnly />
      </RichTextContainer>
    );
  } catch (e) {
    displaySnackbarMessage(`${e}`, 'warning');
    return <>{value}</>;
  }
};

export default RichText;
